import { openCloseToast } from "../../../Global/actions";
import {
  GetInformacionGeneral,
  GetInformacionGeneral2,
  GetInboxSolicitudesApi,
  UpdateDataGestionarSolicitud,
  GetSchedulingofficeApi,
  listaCargos,
  UpdateScheduling,
  GetDatingHorizonApi
} from "../../../../services/solicitudesAgendaSelApi";
import apiConfig from "../../../../config/api";
import validaciones from "../../../../helpers/validaciones";
import trace from "../../../../helpers/trace";
import { showToastError, showMessageApi } from "../../../Main/actions";
import moment from "moment"

export const setSolicitantes = (solicitantes, filtros) => ({
  type: "SET_SOLICITANTES_INBOX",
  solicitantes,
  filtros,
});
export const openCloseModalAgendar = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_AGENDAR_INBOX",
  isOpen,
});

export const setSolicitudesEmpresa = (listaSolicitudes, filtros, total) => ({
  type: "SET_SOLICITUDES_CONFIRMAR_INBOX",
  listaSolicitudes,
  filtros,
  total,
});

export const setSolicitudesEmpresaFiltrada = (listaSolicitudesFiltrada) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_INBOX",
  listaSolicitudesFiltrada,
});

export const setSolicitudesEmpresaFiltradaTotal = (total) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_INBOX",
  total,
});

export const setSolicitudesEmpresaFiltradaFiltros = (filtros) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_INBOX",
  filtros,
});

export const setEstadoSolicitud = (tipo) => ({
  type: "SET_TIPO_SOLICITUD_CONFIRMAR_INBOX",
  tipo,
});

export const showInfoGestionSolicitud = (open) => ({
  type: "SET_SHOW_GESTION_SOLICITUD_INBOX",
  open,
});

export const setSelectedSolicitud = (data) => ({
  type: "SET_SELECTED_SOLICITUD_INBOX",
  data,
});

export const setSelectedSolicitudShow = (data) => ({
  type: "SET_SELECTED_SOLICITUD_SHOW_INBOX",
  data,
});

export const setNewSelectedSolicitud = (data) => ({
  type: "SET_NEW_SELECTED_SOLICITUD_INBOX",
  data,
});

export const setRefreshSelectedSolicitud = (data) => ({
  type: "SET_REFRESH_SELECTED_SOLICITUD_INBOX",
  data,
});

export const loading = (isLoading) => ({
  type: "LOADING_SOLICITUDES_EMPRESA_INBOX",
  isLoading,
});

export const setWorkerSelected = (id) => ({
  type: "SET_WORKER_SELECTED_INBOX",
  id,
});

export const setTipoSolicitud = (tipo) => ({
  type: "SET_TIPO_SOLICITUD_INBOX",
  tipo,
});

export const setCleanInbox = () => ({
  type: "SET_CLEAN_INBOX"
});

export const setGridCupos = (data) => ({
  type: "SET_GRID_CUPOS_INBOX",
  data
})

export const setEmployeeId = (id) => ({
  type: "SET_EMPLOYEE_SELECTED_INBOX",
  id
})

export const setRefreshScheduling = (data) => ({
  type: "SET_REFRESH_SCHEDULING_INBOX",
  data
})

export const setConnectionHub = (connection) => ({
  type: "SET_CONNECTION_HUB",
  connection
})

export const setSchedulingData = (data) => ({
  type: "SET_SCHEDULING_DATA",
  data
})

export const setListaCargos = (data) => ({
  type: "SET_LISTA_CARGOS",
  data
})

export const setDatingHorizon = (data) => ({
  type: "SET_DATING_HORIZON",
  data
})

export const openToast = (toast) => async (dispatch) => {
  dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: toast.msgToast,
    typeStyle: toast.typeStyle,
    displayTime: 5000
  }));
};


export const loadCargos = () => async (dispatch) => {
  try {
    const request = await listaCargos();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setListaCargos(result));
     } else {
      const result = await request.json();
      dispatch(showMessageApi("Error al obtener cargos", request, result));
    }
  } catch (e) {
    dispatch(showToastError());
  }
};

export const loadDataSelected = (id, isShow) => async (dispatch) => {
  try {
    dispatch(loading(true));
    let message;

    const request = await GetInformacionGeneral(id);
    if (request.status === 200) {
      const result = await request.json();
      if (result.WorkersPending > 0) {
        const Worker = {
          Age: null,
          DocumentNumber: "",
          DocumentType: 0,
          Id: "S/D",
          IsScheduling: false,
          Mail: null,
          Name: "Sin Nombre",
          Phone: null,
          SchedulingDate: null,
        };

        for (let i = 0; i < result.WorkersPending; i++) {
          result.Workers.push(Worker);
        }
      }
      if(isShow){
        dispatch(setSelectedSolicitudShow(result))
      }else{
        dispatch(setSelectedSolicitud(result));
        dispatch(showInfoGestionSolicitud(true));
      }
    } else {
      dispatch(showInfoGestionSolicitud(false));
      dispatch(setSelectedSolicitud({}));
      dispatch(setSelectedSolicitudShow(null))
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    dispatch(showInfoGestionSolicitud(false));
    dispatch(setSelectedSolicitud({}));
    dispatch(setSelectedSolicitudShow(null))
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

/*export const loadDataSelectedShow = (row) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetInformacionGeneral(row.data.Id);
    if (request.status === 200) {
      const result = await request.json();

      if (result.WorkersPending > 0) {
        const Worker = (index) => ({
          Age: null,
          Index: index,
          DocumentNumber: "",
          DocumentType: 0,
          Id: null,
          IsScheduling: false,
          Mail: null,
          Name: "Sin Nombre",
          Phone: null,
          SchedulingDate: null,
        });

        for (let i = 0; i < result.WorkersPending; i++) {
          result.Workers.push(Worker(i));
        }
      }

      const requestBaterias = await listaBaterias();
      const resultBaterias = await requestBaterias.json();

      const baterias = resultBaterias && resultBaterias.Pools ? resultBaterias.Pools : [];
      const examenes = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 1 ? e : null).filter((f) => f) : [];
      const psicologicos = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 2 ? e : null).filter((f) => f) : [];
      let defaultCityId = null;
      let defaultCityDescription = null;

      result.Pools = result.Pools.map((e) => {
        const pool = baterias.find((ee) => ee.Id === e.PoolId);
        if (pool) {
          pool.AchsOffices = pool.AchsOffices.map((office) => {
            if (office.Id === e.AchsOfficeId) {
              defaultCityId = office.Id;
              defaultCityDescription = office.Description
            }
            return {
              ...office,
              selected: office.Id === e.AchsOfficeId,
            };
          });
        }
        return pool;
      }).filter((f) => f);

      result.PsychologicalExams = result.PsychologicalExams.map((e) => {
        const exam = psicologicos.find((ee) => ee.Id === e.ExamId);
        if (exam) {
          exam.AchsOffices = exam.AchsOffices.map((office) => {
            if (office.Id === e.AchsOfficeId) {
              defaultCityId = office.Id;
              defaultCityDescription = office.Description
            }
            return {
              ...office,
              selected: office.Id === e.AchsOfficeId,
            };
          });
        }
        return exam;
      }).filter((f) => f);

      result.AdditionalExams = result.AdditionalExams.map((e) => {
        const exam = examenes.find((ee) => ee.Id === e.ExamId);
        if (exam) {
          exam.AchsOffices = exam.AchsOffices.map((office) => {
            if (office.Id === e.AchsOfficeId) {
              defaultCityId = office.Id;
              defaultCityDescription = office.Description
            }
            return {
              ...office,
              selected: office.Id === e.AchsOfficeId,
            };
          });
        }
        return exam;
      }).filter((f) => f);

      result.defaultCityId = defaultCityId;
      result.defaultCityDescription = defaultCityDescription;
      result.isExamsUpdate = false;
      result.isPoolsUpdate = false;
      result.isWorkersUpdate = false;
      dispatch(setSelectedSolicitudShow(result))
    } else {
      dispatch(openCloseModalGestionar(false));
      dispatch(setDataSelected({}));
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    dispatch(openCloseModalGestionar(false));
    dispatch(setDataSelected({}));
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};*/

export const loadNewDataSelected = (id, manage, handleOpenGest, handleCloseGest) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const _result = await loadNewData(id, manage, dispatch);
    if (_result !== null){
      handleOpenGest(1)
      dispatch(setNewSelectedSolicitud(_result));
    }
  } catch (e) {
    handleCloseGest()
    dispatch(setNewSelectedSolicitud({}));
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const loadRefreshDataSelected = (id) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const _result = await loadNewData(id, null, dispatch);
    dispatch(setNewSelectedSolicitud(_result));
  } catch (e) {
    dispatch(setNewSelectedSolicitud({}));
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

const loadNewData = async(id, manage, dispatch) => {
  let message;
  const request = await GetInformacionGeneral2(id, manage);
  if (request.status === 200) {
    const result = await request.json();
    if (result.WorkersPending > 0) {
      const Worker = (i) => ({
        Age: null,
        DocumentNumber: "",
        DocumentType: 0,
        Id: "S/D/"+i,
        IsScheduling: false,
        Mail: null,
        Name: "Sin Nombre",
        Phone: null,
        SchedulingDate: [],
      });

      for (let i = 0; i < result.WorkersPending; i++) {
        result.Workers.push(Worker(i));
      }
    }
    return result
  } else {
    if (request.status === 409){
      const result = {
        Message: "La solicitud está siendo gestionada por otro usuario o puede ya haber sido agendada."
      }
      dispatch(showMessageApi(message, request, result));
      return null
    }else{
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    return ({})
  }
}

export const loadCalendarByDateRange = (id, dateStart, dateEnd, scheduleId) => async (dispatch) =>{
  dispatch(loading(true));
  //dispatch(setGridCupos({dataGridCupos: [], hourRange: []}))
  const _dataReturn = await loadCalendar(dateStart, dateEnd, id, dispatch);
  if(scheduleId){
    const _result = await loadNewData(scheduleId, null, dispatch);
    dispatch(setRefreshScheduling({selectedSolicitud: _result, dataGridCupos: _dataReturn}))
  }else{
    dispatch(setGridCupos({dataGridCupos: _dataReturn}))
  }
  dispatch(loading(false));
}

export const loadDatingHorizon = (id, year, month) => async (dispatch) =>{
  if(id){
    const _result = await loadHorizonData(id, year, month, dispatch);
    dispatch(setDatingHorizon(_result))
  }
}

export const loadHorizonData = async(id, year, month, dispatch) => {
  let message;
  try{
    const request = await GetDatingHorizonApi(id, year, month);
    if (request.status === 200) {
      const result = await request.json();
      return result
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
      return [];
    }

  } catch (e) {
    trace.error("loadDataGrid", e);
    dispatch(showToastError());
    return [];
  }
}

const loadCalendar = async(dateStart, dateEnd, id, dispatch) => {
  let message;
  try{
    const request = await GetSchedulingofficeApi({
      startScheduling: dateStart,
      endScheduling: dateEnd,
      officeId: id
    });
    if (request.status === 200) {
      const result = await request.json();
      return result
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
      return [];
    }

  } catch (e) {
    trace.error("loadDataGrid", e);
    dispatch(showToastError());
    return [];
  }
}

export const reserveScheduling = (worker, cupo, solicitud, estado, officeId, currentDate, userRut, typeAmount, connectionHub) => async (dispatch) => {
  dispatch(loading(true));
  if(!worker){
    dispatch(showToastError('Debe seleccionar un trabajdor "Pendiente"'));
  }
  /*
  Disponible = 1,
  Bloqueado = 2,
  Agendado = 3,
  Reservado = 4
  */
  try {
    let _data = {
      "WorkerScheduling":{
        "RequestId": solicitud.Id,
        "WorkersScheduling":[
          {
            "OpeningQuotaId": cupo.OpeningQuotaId,
            "WorkerId": worker.Id,
            "StatusWorkerScheduling": estado,
            "TypeAmountQuota": typeAmount,
            "Scheduling": [
              {
                "QuotaType": cupo.QuotaId
              }
            ]
          }
        ],
        "StatusSchedulingRequest": estado
      },
      "Rut": userRut,
      "StartScheduling": currentDate,
      "EndScheduling": currentDate,
      "StartTime": cupo.StartTime,
      "EndTime": cupo.EndTime,
      "QuotaId": null,
      "OfficeId": officeId,
      "TypeAmountQuota": null,
    }
    await connectionHub.invoke("saveWorkerScheduling", _data);
  } catch (e) {
    trace.error("updateDataGestionar", e);
    dispatch(showToastError());
  }
}

export const deleteSchedule = (scheduleData, connectionHub, userRut, officeId, mClose) => async (dispatch) => {
  dispatch(loading(true));
  var dateList = [];
  scheduleData.Workers.forEach(e => {
    let _dates = e.SchedulingDates.filter(e => !!e.DescriptionQuotaType).map(e => e.Date)
    dateList = [...dateList, ..._dates]
  });
  var _startDate = null
  var _endDate = null
  if(dateList.length > 0){
    dateList.forEach(e => {
      let _e = moment(e).startOf('day');
      if(!_startDate) _startDate = _e.format();
      if(!_endDate) _endDate = _e.format();
      if(moment(_startDate).isAfter(_e))
        _startDate = _e.format()
      if(moment(_endDate).isBefore(_e))
        _endDate = _e.format()
    });
  }
  try {
    const data = {
      "RequestId": scheduleData.Id,
      "Rut":userRut,
      "QuotaId":null,
      "OfficeId":officeId.AchsOfficeId,
      "TypeAmmountQuota":null
    }

    if(_startDate && _endDate){
      const dateData = {
        "StartScheduling": _startDate,
        "EndScheduling": _endDate
      }
      Object.assign(data, dateData);
    }

    //connectionHub.invoke("deleteWorkerScheduling", scheduleData); //individual
    await connectionHub.invoke("deleteAllWorkerScheduling", data); //all
  } catch (e) {
    trace.error("deleteSchedule", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
  mClose();
  return true;
}

export const deleteScheduleWorker = (scheduleData, worker,  connectionHub, userRut, idOffice, quotaType) => async (dispatch) => {
  dispatch(loading(true));
  const _schedule = worker.SchedulingDates.find(e => e.QuotaType === quotaType)
  const _date = moment(_schedule.Date).startOf('day').format();
  const data = {
    Key: _schedule.StartTime,
    Rut: userRut,
    RequestId: scheduleData.Id,
    WorkerId: worker.Id,
    RutWorker: worker.DocumentNumber,
    StartScheduling: _date,
    EndScheduling: null,
    StartTime: _schedule.StartTime,
    EndTime: _schedule.EndTime,
    QuotaId: quotaType,
    OfficeId: idOffice.AchsOfficeId,
    TypeAmountQuota: null
  }
  try {
    await connectionHub.invoke("deleteWorkerScheduling", data); //individual
  } catch (e) {
    trace.error("deleteScheduleWorker", e);
    dispatch(showToastError());
  }
  return true;
}

export const rejectSchedule = (data, scheduleData, connectionHub, mClose, mLoadDataGrid, userRut, officeId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await UpdateDataGestionarSolicitud(data);
    if (request.status === 200) {
      var dateList = [];
      scheduleData.Workers.forEach(e => {
        let _dates = e.SchedulingDates.filter(e => !!e.DescriptionQuotaType).map(e => e.Date)
        dateList = [...dateList, ..._dates]
      });
      var _startDate = null
      var _endDate = null
      dateList.forEach(e => {
        let _e = moment(e).startOf('day');
        if(!_startDate) _startDate = _e.format();
        if(!_endDate) _endDate = _e.format();
        if(moment(_startDate).isAfter(_e))
          _startDate = _e.format()
        if(moment(_endDate).isBefore(_e))
          _endDate = _e.format()
      })
      const _data = {
        "RequestId": scheduleData.Id,
        "Rut":userRut,
        "StartScheduling": _startDate,
        "EndScheduling": _endDate,
        "QuotaId":null,
        "OfficeId":officeId.AchsOfficeId,
        "TypeAmmountQuota":null
      }
      await connectionHub.invoke("deleteAllWorkerScheduling", _data); //all
      message = "La solicitud ha sido rechazada correctamente.";
      mLoadDataGrid()
      mClose();
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    dispatch(showMessageApi(message, request));
  } catch (e) {
    trace.error("updateDataGestionar", e);
    dispatch(showToastError());
  }
}

export const loadDataGrid = (filtros) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    dispatch(setSolicitudesEmpresaFiltrada([]));
    const request = await GetInboxSolicitudesApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setSolicitudesEmpresa([...result.Data], null, null));
      dispatch(doGetSolicitudesFilters(result.Data));
      dispatch(setSolicitudesEmpresaFiltrada([...result.Data]));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("loadDataGrid", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const updateDataGestionar = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await UpdateDataGestionarSolicitud(data);
    if (request.status === 200) {
      dispatch(showInfoGestionSolicitud(false));
      message = "La solicitud ha sido rechazada correctamente.";
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    dispatch(showMessageApi(message, request));
  } catch (e) {
    trace.error("updateDataGestionar", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetSolicitudesFilters = (ListaSolicitudes) => async (dispatch) => {
  try {
    const filtros = [
      { column: "ProposalDate", name: "Fecha propuesta - inicio", type: "date" },
      { column: "ProposalDateEnd", name: "Fecha propuesta - fin", type: "date" },
      { column: "ApprovalDate", name: "Fecha aprobación", type: "date" },
      { column: "RejectCallCenterDate", name: "Fecha de rechazo", type: "date" },

    ];
    let Aprobador = ListaSolicitudes.map((item) => ({ text: item.AuthorizedName, value: item.AuthorizedName })).filter((e) => e.text && e.value);
    Aprobador = validaciones.getUnique(Aprobador, "text");
    let CompanyName = ListaSolicitudes.map((item) => ({ text: item.CompanyName, value: item.CompanyName })).filter((e) => e.text && e.value);
    CompanyName = validaciones.getUnique(CompanyName, "text");
    filtros.push(
      {
        column: "AuthorizedName", name: "Aprobador", values: Aprobador,
      },
      {
        column: "CompanyName", name: "Empresa", values: CompanyName,
      }
    );
    dispatch(setSolicitudesEmpresaFiltradaFiltros(filtros));
  } catch (e) {
    trace.error("doGetSolicitudesFilters", e);
    dispatch(showToastError());
  }
};
